import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux'
import { change } from 'redux-form';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';

import restClient from '../../services/restClient';
import { appOptions } from '../../config/app';

const styles = {
  container: {
    border: '1px solid #ddd',
    backgroundColor: '#eee',
    padding: '16px',
    display: 'flex',
    marginTop: '16px'

  },
  text: {
    verticalAlign: 'middle',
    marginRight: '16px',
    flex: '1'

  },
  button: {
    verticalAlign: 'middle',
    marginLeft: '16px',
  }
};

class LoadCategoriesField extends React.Component {;
  state = {
    link: this.props.record && this.props.record.domain,
    xpath: this.props.record && this.props.record.xpaths && this.props.record.xpaths.categories,
  };

  LoadCategories = () => {
    const { record } = this.props;
    const apiClient = restClient(appOptions);
    apiClient('CRAWL', 'mediasources/xpath', {data: this.state}).then(res => {
      if(res.data && Array.isArray(res.data)){
        const categories = res.data.map(c => ({name: c, ref: "99", type: "text", order: 1}))
        if(record.categories) categories.push(...record.categories);
        this.props.changeCategories(categories);
      }
    });
  };

  RemoveCategories = () => {
    const categories = [{name: "", ref: "99", type: "default", order: 1}];
    this.props.changeCategories(categories);
  };

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    });
  };

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.container}>
        <TextField label="Link" className={classes.text} value={this.state.link} onChange={ this.handleChange('link') } />
        <TextField label="Xpath" className={classes.text} value={this.state.xpath} onChange={ this.handleChange('xpath') } />
        <Button variant="outlined" className={classes.button} color="primary" onClick={this.LoadCategories}>Load</Button>
        <Button variant="outlined" className={classes.button} color="secondary" onClick={this.RemoveCategories}>Clear all</Button>
      </div>
    );
  }
}

LoadCategoriesField.propTypes = {
    classes: PropTypes.object.isRequired,
    record: PropTypes.object,
};

export default connect(null, {
    changeCategories: val => change('record-form', "categories", val),
})(withStyles(styles)(LoadCategoriesField));


// WEBPACK FOOTER //
// ./src/resources/ui/LoadCategoriesField.js